import { axiosInstance as request } from '@/api/rest.service'

export const getArticle = id => request.get(`/research-output/articles/${id}?include=subject_areas`)
export const updateArticle = (id, payload) => request.patch(`/research-output/articles/${id}`, payload)
